import { render, staticRenderFns } from "./Add2Homescreen.vue?vue&type=template&id=20ae937e"
import script from "./Add2Homescreen.vue?vue&type=script&lang=js"
export * from "./Add2Homescreen.vue?vue&type=script&lang=js"
import style0 from "./Add2Homescreen.vue?vue&type=style&index=0&id=20ae937e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports